import { gql } from '@apollo/client';

/*
 ** GET DROPDOWNS (ingest_region, ingest_format, content_type, dvr_window, stream_type) **
 */

export const GET_DROPDOWNS = gql`
  query getDropdowns($ddType: ddTypeEnum!) {
    getDropdowns(ddType: $ddType) {
      dropdowns {
        ddId
        ddLabel
        ddValue
        ddType
      }
    }
  }
`;

export type DropdownType = 'ingest_region' | 'ingest_format' | 'content_type' | 'dvr_window' | 'stream_type';

export type BroadcastDropdown = {
  ddId: string;
  ddLabel: string;
  ddValue: string;
  ddType: DropdownType;
};

export type GetDropdownsData = {
  getDropdowns: {
    dropdowns: BroadcastDropdown[];
  } | null;
};

export type GetDropdownsVariables = {
  ddType: DropdownType;
};

/*
 ** GET BROADCAST LIVE BY ID **
 */

export const GET_BROADCAST_LIVE = gql`
query GetBroadcastLive($blId: String) {
  getBroadcastLive(blId: $blId) {
    broadcastLive {
      blId
      blTitle
      blDescription
      blThumbnailUrl
      blStreamType
      blStatus
      blIngestRegion
      blIngestFormat
      blStartTime
      blEndTime
      blJwStreamId
      blStreamUrl
      blStreamKey
      blHlsPlayoutUrl
      blDashPlayoutUrl
      blDvrWindow
      blClippingWindow
      blClippingWindowDisplayName
      blFrameRate
      blIsLive
      blHlsPreviewPlayoutUrl
      blDashPreviewPlayoutUrl
      blCreatedAt
      blUpdatedAt
      mediaApproval {
        maId
        maJwThumbNailUrl
        maS3ThumbnailKeyUrl
        maJwThumbnailId
      }
    }
  }
}
`;

export type BroadcastLiveMediaApproval = {
  maId: string;
  maJwThumbNailUrl: string | null;
  maS3ThumbnailKeyUrl: string | null;
  maJwThumbnailId: string | null;
};

export type BroadcastLive = {
  blId: string;
  blTitle: string;
  blDescription: string | null;
  blThumbnailUrl: string | null;
  blStreamType: string | null;
  blStatus: string | null;
  blStatusStr: string | null;
  blIngestRegion: string | null;
  blIngestFormat: string | null;
  blStartTime: string | null;
  blEndTime: string | null;
  blJwStreamId: string;
  blStreamUrl: string | null;
  blStreamKey: string | null;
  blHlsPlayoutUrl: string | null;
  blDashPlayoutUrl: string | null;
  blDvrWindow: number | null;
  blClippingWindow: string | null;
  blClippingWindowDisplayName: string | null;
  blFrameRate: string | null;
  blIsLive: boolean | null;
  blHlsPreviewPlayoutUrl: string | null;
  blDashPreviewPlayoutUrl: string | null;
  blCreatedAt: string | null;
  blUpdatedAt: string | null;
  mediaApproval?: BroadcastLiveMediaApproval | null;
};

export type GetBroadcastLiveData = {
  getBroadcastLive: {
    broadcastLive: BroadcastLive | null;
  };
};

export type GetBroadcastLiveVariables = {
  blId: string;
};


export const GET_ALL_BROADCASTS_LIVE = gql`
  query GetAllBroadcastLive($offset: Int, $limit: Int) {
    getAllBroadcastLive(offset: $offset, limit: $limit) {
      BroadcastLiveItems {
        blId
        blTitle
        blDescription
        blThumbnailUrl
        blStreamType
        blStatus
        blStatusStr
        blIsLive
        blIngestRegion
        blIngestFormat
        blStartTime
        blEndTime
        blJwStreamId
        blStreamUrl
        blStreamKey
        blHlsPlayoutUrl
        blDashPlayoutUrl
        blDvrWindow
        blClippingWindow
        blFrameRate
        blCreatedAt
        blUpdatedAt
        mediaApproval {
          maId
          maJwThumbNailUrl
          maS3ThumbnailKeyUrl
          maJwThumbnailId
        }
      }
      total
    }
  }
`;



export type BroadcastLiveItem = {
  blId: string;
  blTitle: string;
  blDescription: string;
  blThumbnailUrl: string;
  blStreamType: string;
  blStatus: 'scheduled' | 'live';
  blStatusStr: string;
  blIsLive?: boolean | null;
  blIngestRegion: string;
  blIngestFormat: string;
  blStartTime: string;
  blEndTime: string;
  blJwStreamId: string;
  blStreamUrl: string;
  blStreamKey: string;
  blHlsPlayoutUrl: string;
  blDashPlayoutUrl: string;
  blDvrWindow: number;
  blClippingWindow: number;
  blFrameRate: number;
  blCreatedAt: string;
  blUpdatedAt: string;
  mediaApproval: {
    maId: string;
    maJwThumbNailUrl: string;
    maS3ThumbnailKeyUrl: string;
    maJwThumbnailId: string;
  };
};

export type GetAllBroadcastLiveData = {
  getAllBroadcastLive: {
    BroadcastLiveItems: BroadcastLiveItem[];
    total: number;
  }
}

export type GetAllBroadcastLiveVariables = {
  offset: number;
  limit: number;
}


// for stream
export const START_LIVE_STREAM = gql`
  mutation StartLiveStream($blId: String, $streamId: String) {
    startLiveStream(blId: $blId, streamId: $streamId)
  }
`;

export type StartLiveStreamData = {
  startLiveStream: string;
}

export type StartLiveStreamVariables = {
  streamId: string;
}


// for go live
export const GO_LIVE_STREAM = gql`
  mutation GoLiveStream($blId: String, $streamId: String) {
    goLiveStream(blId: $blId, streamId: $streamId)
  }
`;

export type GoLiveStreamVariables = {
  blId?: string;
  streamId: string;
};

export type GoLiveStreamData = {
  goLiveStream: string;
};

// for stop
export const STOP_LIVE_STREAM = gql`
  mutation StopLiveStream($blId: String, $streamId: String) {
    stopLiveStream(blId: $blId, streamId: $streamId)
  }
`;

export type StopLiveStreamVariables = {
  blId?: string;
  streamId: string;
};

export type StopLiveStreamData = {
  stopLiveStream: string;
};
